import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bcd8ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-mgmt-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-mgmt-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "订单管理")
], -1))
const _hoisted_3 = { class: "filter-bar" }
const _hoisted_4 = {
  key: 0,
  class: "order-info-cell"
}
const _hoisted_5 = { class: "order-id-row" }
const _hoisted_6 = { class: "goods-name-row" }
const _hoisted_7 = { class: "amount-row" }
const _hoisted_8 = {
  key: 3,
  class: "auth-info-cell"
}
const _hoisted_9 = { class: "auth-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-label" }, "邮箱", -1))
const _hoisted_11 = { class: "auth-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-label" }, "授权", -1))
const _hoisted_13 = { class: "auth-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-label" }, "结果", -1))
const _hoisted_15 = { class: "pagination" }

import { ref, onMounted } from 'vue'
import axios from 'axios'
import { message, Modal } from 'ant-design-vue'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderManageView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const orderList = ref<any[]>([])
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(20)
const total = ref(0)
const filterStatus = ref<number | undefined>(undefined)
const filterOrderId = ref('')

// 详情弹窗
const detailDialogVisible = ref(false)
const currentOrder = ref<any>({})

// 修改弹窗
const editDialogVisible = ref(false)
const editForm = ref({
    order_id: '',
    auth_value: '',
    email: '',
})
const submitting = ref(false)

const columns = [
    { title: '订单信息', key: 'orderInfo', minWidth: 260 },
    { title: '数量', dataIndex: 'quantity', key: 'quantity', width: 70 },
    { title: '状态', key: 'status', width: 90 },
    { title: '支付模式', key: 'pay_mode', width: 100 },
    { title: '授权信息', key: 'authInfo', minWidth: 220 },
    { title: '下单时间', dataIndex: 'created_at', key: 'created_at', width: 170 },
    { title: '操作', key: 'action', width: 230, fixed: 'right' },
]

const statusText = (status: number) => {
    const map: Record<number, string> = { 0: '待支付', 1: '已完成', 2: '已取消' }
    return map[status] || '未知'
}

const statusTagType = (status: number) => {
    const map: Record<number, string> = { 0: 'gold', 1: 'green', 2: 'default' }
    return map[status] || 'default'
}

const getOrderList = async () => {
    loading.value = true
    try {
        const params: any = {
            page: currentPage.value,
            pageSize: pageSize.value,
        }
        if (filterStatus.value !== undefined && filterStatus.value !== '') {
            params.status = filterStatus.value
        }
        if (filterOrderId.value) {
            params.order_id = filterOrderId.value
        }
        const res = await axios.post(baseURL + '/api/shop/tenant/order/list', params, { headers })
        if (res.data.code === 0) {
            const data = res.data.data
            orderList.value = data.list || []
            total.value = data.total || 0
        } else {
            message.error(res.data.msg || '获取订单列表失败')
        }
    } catch (e: any) {
        message.error('获取订单列表失败：' + e.message)
    } finally {
        loading.value = false
    }
}

const handleFilter = () => {
    currentPage.value = 1
    getOrderList()
}

const resetFilter = () => {
    filterStatus.value = undefined
    filterOrderId.value = ''
    currentPage.value = 1
    getOrderList()
}

const openDetailDialog = (row: any) => {
    currentOrder.value = { ...row }
    detailDialogVisible.value = true
}

const openEditDialog = (row: any) => {
    editForm.value = {
        order_id: row.order_id,
        auth_value: row.auth_value || '',
        email: row.email || '',
    }
    editDialogVisible.value = true
}

const submitEdit = async () => {
    submitting.value = true
    try {
        const payload: any = { order_id: editForm.value.order_id }
        if (editForm.value.auth_value) payload.auth_value = editForm.value.auth_value
        if (editForm.value.email) payload.email = editForm.value.email
        const res = await axios.post(baseURL + '/api/shop/tenant/order/update', payload, { headers })
        if (res.data.code === 0) {
            message.success('修改成功')
            editDialogVisible.value = false
            getOrderList()
        } else {
            message.error(res.data.msg || '修改失败')
        }
    } catch (e: any) {
        message.error('修改失败：' + e.message)
    } finally {
        submitting.value = false
    }
}

const markPaid = (row: any) => {
    Modal.confirm({
        title: '确认标记已支付',
        content: `确认将订单「${row.order_id}」标记为已支付吗？\n标记后系统将执行扣款、授权、反利等逻辑，此操作不可撤销。`,
        okText: '确认标记',
        cancelText: '取消',
        onOk: async () => {
            try {
                const res = await axios.post(baseURL + '/api/shop/tenant/order/markPaid', { order_id: row.order_id }, { headers })
                if (res.data.code === 0) {
                    message.success('订单已标记为已支付')
                    getOrderList()
                } else {
                    message.error(res.data.msg || '操作失败')
                }
            } catch (e: any) {
                message.error('操作失败：' + e.message)
            }
        },
    })
}

onMounted(() => {
    getOrderList()
})

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"min-height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(UserHead),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: {"padding":"0","background":"#fff","border-bottom":"1px solid #f0f0f0"} }, {
            default: _withCtx(() => [
              _createVNode(UserHeadTop)
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { class: "order-mgmt-content-div" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_select, {
                    value: filterStatus.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((filterStatus).value = $event)),
                    placeholder: "订单状态",
                    allowClear: "",
                    style: {"width":"140px"},
                    onChange: handleFilter
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("待支付")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("已完成")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("已取消")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_a_input, {
                    value: filterOrderId.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((filterOrderId).value = $event)),
                    placeholder: "搜索订单号",
                    allowClear: "",
                    style: {"width":"220px"},
                    onChange: handleFilter,
                    onPressEnter: handleFilter
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: handleFilter
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, { onClick: resetFilter }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_a_table, {
                  "data-source": orderList.value,
                  columns: columns,
                  loading: loading.value,
                  "row-key": "order_id",
                  class: "order-mgmt-table",
                  size: "middle",
                  pagination: false
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'orderInfo')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(record.order_id), 1),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(record.goods_name), 1),
                          _createElementVNode("div", _hoisted_7, "￥" + _toDisplayString(record.amount), 1)
                        ]))
                      : (column.key === 'status')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: statusTagType(record.status),
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.status_text || statusText(record.status)), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : (column.key === 'pay_mode')
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 2,
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(record.pay_mode === 'tenant' ? '自定义收款' : '系统收款'), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (column.key === 'authInfo')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _hoisted_10,
                                  _createElementVNode("span", null, _toDisplayString(record.email || '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _hoisted_12,
                                  _createElementVNode("span", null, _toDisplayString(record.auth_value || '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createElementVNode("span", null, _toDisplayString(record.auth_result || '-'), 1)
                                ])
                              ]))
                            : (column.key === 'action')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createVNode(_component_a_button, {
                                    size: "small",
                                    onClick: ($event: any) => (openDetailDialog(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("详情")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  (record.status === 0)
                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                        key: 0,
                                        size: "small",
                                        onClick: ($event: any) => (openEditDialog(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("修改")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (record.status === 0 && record.pay_mode === 'tenant')
                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                        key: 1,
                                        size: "small",
                                        type: "primary",
                                        ghost: "",
                                        onClick: ($event: any) => (markPaid(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("标记已付")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data-source", "loading"]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_pagination, {
                    current: currentPage.value,
                    "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
                    "page-size": pageSize.value,
                    "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
                    total: total.value,
                    "show-size-changer": "",
                    "page-size-options": [10, 20, 50],
                    "show-total": (t) => `共 ${t} 条`,
                    onChange: getOrderList,
                    onShowSizeChange: getOrderList
                  }, null, 8, ["current", "page-size", "total", "show-total"])
                ])
              ]),
              _createVNode(_component_a_modal, {
                open: detailDialogVisible.value,
                "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((detailDialogVisible).value = $event)),
                title: "订单详情",
                width: "600px",
                footer: null
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (detailDialogVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("关闭")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_descriptions, {
                    column: 1,
                    bordered: "",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions_item, { label: "订单号" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.order_id), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "商品名称" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.goods_name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "订单金额" }, {
                        default: _withCtx(() => [
                          _createTextVNode("￥" + _toDisplayString(currentOrder.value.amount), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "购买数量" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.quantity), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "订单状态" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, {
                            color: statusTagType(currentOrder.value.status),
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(currentOrder.value.status_text || statusText(currentOrder.value.status)), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "支付模式" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.pay_mode === 'tenant' ? '自定义收款' : '系统收款'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "支付渠道" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.pay_type), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "下单邮箱" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.email), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "授权字段" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.auth_value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "授权结果" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.auth_result || '-'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "查询密码" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.query_password), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "下单时间" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.created_at), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "支付时间" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentOrder.value.paid_at || '-'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["open"]),
              _createVNode(_component_a_modal, {
                open: editDialogVisible.value,
                "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((editDialogVisible).value = $event)),
                title: "修改订单",
                width: "500px",
                "mask-closable": false,
                footer: null
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (editDialogVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: submitEdit,
                    loading: submitting.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认修改")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_form, {
                    model: editForm.value,
                    layout: "vertical"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "订单号" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            "model-value": editForm.value.order_id,
                            disabled: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "授权字段" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: editForm.value.auth_value,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.auth_value) = $event)),
                            placeholder: "请输入授权字段值"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "下单邮箱" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: editForm.value.email,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.email) = $event)),
                            placeholder: "请输入邮箱"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              }, 8, ["open"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})